import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";

const DatasourceAutomaatGo = (props) => {

    const Fields = [
        {Identifier:"ApiUrl", Translation:Translate("API URL"), Required:true},
        {Identifier:"ApiKey", Translation:Translate("API key"), Required:true},
        {Identifier:"SerialNumber", Translation:Translate("Serial number"), Required:true},
        {Identifier:"CdKey", Translation:Translate("CD key"), Required:true}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceAutomaatGo.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceAutomaatGo